/** @graphql cc **/

import gql from 'graphql-tag';

export const PublishModalWithMoreOptionsQuery = gql`
	query PublishModalWithMoreOptionsQuery($contentId: ID) {
		singleContent(id: $contentId) {
			id
			type
			space {
				id
			}
			schedulePublishInfo {
				date
				versionComment
				minorEdit
				targetType
				targetLocation {
					parentId
					destinationSpace {
						id
						key
						alias
					}
				}
				restrictions {
					update {
						user: personConnection {
							edges {
								node {
									email
									permissionType
									displayName
									accountId
									publicName
									profilePicture {
										path
									}
								}
							}
						}
						group {
							edges {
								node {
									name
									id
								}
							}
						}
					}
					read {
						user: personConnection {
							edges {
								node {
									email
									permissionType
									displayName
									accountId
									publicName
									profilePicture {
										path
									}
								}
							}
						}
						group {
							edges {
								node {
									name
									id
								}
							}
						}
					}
				}
			}
		}
	}
`;
